import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
          mouseenter: {
              menuHover: 'menuOpen'
          },
          mouseleave: {
            menuHover: 'menuClose'
          }
        };
    }

    menuOpen() {
      document.documentElement.classList.add("has-menu-open");
      this.$('menuItemLink')[0].classList.add('c-header_menu_link--active');
    }

    menuClose() {
      document.documentElement.classList.remove("has-menu-open");
      this.$('menuItemLink')[0].classList.remove('c-header_menu_link--active');
  }
}
